export class filtro {
    mixer: any;
    plant: any[];
    fechaDesde: any;
    fechaHasta: any;
    tConoL: any;
    tConoH: any;
}

export class datosAnual{
    fecha: any[];
    dConos: datosAnualPlanta[];
    dTolerancia: datosAnualPlanta[];
    dRPM: datosAnualPlanta[];
    dVacio: datosAnualPlanta[];
}
export class datosAnualPlanta{
    data: any[];//porcentajes
    name: any;// planta
}

export class auth{
    usuario: string;
    password: string;
    cliente: string;
}

export class cambio{
    newPassword: string;
    oldPassword: string;
    cliente: string;
    usuario: string;
}

export class newContraseña{
    email: string;
    cliente: string;
    user: string;
}

export class obtenerCertificado {
    cliente : any;
    obra: any;
    numeroMuestra: any;
    certificado: any;
}


// WEBPACK FOOTER //
// ./src/app/models/ejemplo.model.ts